import React from 'react'
import { Grid } from '@material-ui/core'
import { components } from 'cng-web-lib'
import NaCountryCodeApiUrls from 'src/apiUrls/NaCountryCodeApiUrls'
import FormProperties from './FormProperties'
import pathMap from 'src/paths/pathMap'

const {
  form: { CngAddForm },
} = components

function AddPage({ history, showNotification }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngAddForm
          fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
          history={history}
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: NaCountryCodeApiUrls.POST,
            successRedirect: pathMap.NA_COUNTRY_CODE_LIST_VIEW,
          }}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage
